import { render, staticRenderFns } from "./AceptarTerminos.vue?vue&type=template&id=5c8979d6"
import script from "./AceptarTerminos.vue?vue&type=script&lang=js"
export * from "./AceptarTerminos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports